export default {
  TOKEN: 'HEARTBEAT_TOKEN',
  REFRESH_TOKEN: 'HEARTBEAT_REFRESH_TOKEN'
};



// WEBPACK FOOTER //
// ./src/store/local-storage-keys.js